import { makeStyles } from '@material-ui/styles'
import clsx from 'clsx'
import React from 'react'
import ReactSlider from 'react-slider'
import Text from 'core/elements/Text'
import Theme from 'core/themes/model'

const useStyles = makeStyles<Theme>((theme) => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
  },
  slider: {
    flexGrow: 1,
    background: 'white',
  },
  track: {
    background: theme.palette.grey[200],
    height: 4,
    '&-0': {
      background: theme.palette.blue[700],
    },
  },
  sliderThumb: {
    width: 16,
    height: 16,
    border: `1px solid ${theme.palette.blue[700]}`,
    borderRadius: '50%',
    top: -7,
    background: theme.palette.grey['000'],
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '&:focus-visible': {
      outline: 'initial',
    },
  },
  sliderThumbDot: {
    width: 4,
    height: 4,
    borderRadius: '50%',
    background: theme.palette.blue[700],
  },
  label: {
    fontSize: 12,
  },
  labelDisabled: {
    color: theme.palette.grey[500],
  },
}))

interface Props {
  min: number
  max: number
  step: number
  minLabel: string
  maxLabel: string
  value: number
  onChange: (value: number) => void
  disabled?: boolean
}

export default function Slider({
  min,
  max,
  step,
  minLabel,
  maxLabel,
  onChange,
  value,
  disabled,
}: Props) {
  const classes = useStyles()

  return (
    <div className={classes.container}>
      <Text
        variant="body2"
        className={clsx(classes.label, {
          [classes.labelDisabled]: disabled,
        })}
      >
        {minLabel}
      </Text>
      <ReactSlider
        className={classes.slider}
        min={min}
        max={max}
        onChange={onChange}
        step={step}
        trackClassName={classes.track}
        renderThumb={(props, state) => (
          <div {...props} className={classes.sliderThumb}>
            <div className={classes.sliderThumbDot} />
          </div>
        )}
        value={value}
      />
      <Text
        variant="body2"
        className={clsx(classes.label, {
          [classes.labelDisabled]: disabled,
        })}
      >
        {maxLabel}
      </Text>
    </div>
  )
}
